<template>

  <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" expand="expand" :headers="columns" :items="items">
    <template slot="items" slot-scope="props">
      <tr>
        <td class="icon" :style="elementStyle">
          <div class="icon">
            <v-icon small="small" v-if="props.item[childname].length === 0" :disabled="true">mdi-checkbox-blank</v-icon>
            <v-icon small="small" v-else-if="props.expanded" @click="props.expanded = !props.expanded">mdi-minus-box</v-icon>
            <v-icon small="small" v-else @click="props.expanded = !props.expanded">mdi-plus-box</v-icon>
          </div>
        </td>
        <slot name="item" :item="props.item"></slot>
      </tr>
    </template>
    <template slot="expand" slot-scope="props">
      <TreeView :items="props.item[childname]" :deepness="deepness + 1" :childname="childname">
        <template slot="item" slot-scope="childProps">
          <slot name="item" :item="childProps.item"></slot>
        </template>
      </TreeView>
    </template>
  </v-data-table>

</template>

<script>

import TreeView from './TreeView'

export default {
  name: 'TreeView',
  components: {
    TreeView
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    deepness: {
      type: Number,
      default: 0
    },
    childname: {
      type: String,
      default: 'childrens'
    }
  },
  data: () => ({
    columns: [{
      text: 'Icon'
    }, {
      text: 'Name'
    }, {
      text: 'Actions'
    }]
  }),
  computed: {
    elementStyle () {
      return {
        width: (60 + this.deepness * 25).toString() + 'px',
        textAlign: 'right'
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.tree-view-element {
  display: grid;
  grid-template-columns: 20px 1fr;
  align-items: center;
  grid-template-areas: "toggle content";

  &:hover {
    background-color: #eee;
  }

  &:not(.first) {
    border-top: 1px solid #ddd;
  }
}

.show-bt {
  grid-area: toggle;
}

.content {
  grid-area: content;
}

.container {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/common/TreeView.vue